<!-- KYMW6001 商品画像情報 -->
<div class="contents-area">
  <!-- 検索条件 -->
  <div class="block-row">
    
    <div class="column-list">
      <label class="list-input-title">受注コード</label>
      <div class="list-input-content">
        <input type="text" readonly value="{{kymw6001Model.orderCode}}">
      </div>
      <label class="list-input-title">部門</label>
      <div class="list-input-content">
        <input type="text" readonly value="{{displayClass}}">
      </div>
    </div>
    
    <div class="column-list">
      <label class="list-input-title">受注企画回（翌週）</label>
      <div class="list-input-content" style="width: 100px;">
        <input type="text" readonly value="{{kymw6001Model.catalogId}}">
      </div>
      <label class="list-input-title">Pコード</label>
      <div class="list-input-content" style="width: 100px;">
        <input type="text" readonly value="{{kymw6001Model.pCode}}">
      </div>
    </div>

    <!-- マルチクロス、画面未指定、未確認 -->
    <div class="column-list">
      <label class="list-input-title">媒体</label>
      <div class="list-input-content" style="white-space: nowrap;">
        <input type="text" readonly value="{{displayMedium}}">
      </div>
      <label class="list-input-title">マルチ・クロス</label>
      <div class="list-input-content" style="width: 82px;">
        <input type="text" readonly value="{{kymw6001Model.multiOrCrossFlg === '1' ? '対象': ''}}">
      </div>
    </div>
    
    <div class="column-list">
      <label class="list-input-title">特集コード</label>
      <div class="list-input-content">
        <input type="text" readonly value="{{displayFeature}}">
      </div>
      <label class="list-input-title">画像未指定</label>
      <div class="list-input-content" style="width: 82px;">
        <input type="text" readonly value="{{kymw6001Model.imageNoUseFlag === '1' ? '対象': ''}}">
      </div>
    </div>

    <div class="column-list" style="margin-top: 37px;">
      <label class="list-input-title">未確認</label>
      <div class="list-input-content" style="width: 82px;">
        <input type="text" readonly value="{{kymw6001Model.imageCheckFlag === '1' ? '対象': ''}}">
      </div>
    </div>
  </div>

  <!-- 検索結果一覧 -->
  <div id="hli_UseImageList" #hli_UseImageList [tabindex]="0" 
    style="position:relative;">
    <div class="action-area">
      <app-pager #selectedPager [prevDisabled]="kymw6001Model.totalNum === 0 || kymw6001Model.startDispNum <= 20"
        [nextDisabled]="kymw6001Model.totalNum === 0 || kymw6001Model.endDispNum === kymw6001Model.totalNum"
        [totalNum]="kymw6001Model.totalNum" [startNum]="kymw6001Model.startDispNum"
        [endNum]="kymw6001Model.endDispNum"
        (prevHandler)="eventDisplaySelectedList_CLICKHandler(1)"
        (nextHandler)="eventDisplaySelectedList_CLICKHandler(2)">
      </app-pager>
    </div>
    <div class="useImageList">
      <label class="image-list-header goods-image-info">商品画像情報</label>
      <label class="image-list-header goods-image-check" style="text-align: center;">確認</label>
      <div class="grid-image-list" style="display: flex; width: 100%;" *ngFor="let item of kymw6001Model.imageListInfo; let ind = index;">
        <div class="goods-image-info" style="display: flex; flex-direction: column; ">
          <div class="block-row {{ (item.multiOrCrossFlg.includes('M') || item.multiOrCrossFlg.includes('C')) ? 'multi-cross-color' : '' }}" style="padding: 4px 8px;">
            <label style="width: 9rem;">Pコード：{{item.pCode}}</label>
            <label style="width: 20rem;">部門：{{item.classCode}}：{{item.classNameKanji}}</label>
            <label style="width: 35rem;">商品名：{{item.guideGoodsName}}</label>
            <label style="width: 22rem;">規格名：{{item.guideStandardName}}</label>
            <label style="width: 10rem;">マルチ・クロス：{{item.multiOrCrossFlg}}</label>
          </div>
          <div *ngFor="let imageItem of item.orderImageListInfo; let imageInd = index;" style="background-color: white; border-bottom: none;">
            <label class="goods-image-info-order">注文コード</label>
            <label class="goods-image-info-order">い：{{imageItem.displayOrderNum142}}</label>
            <label class="goods-image-info-order">と：{{imageItem.displayOrderNum163}}</label>
            <label class="goods-image-info-order">ぐ：{{imageItem.displayOrderNum185}}</label>
            <label class="goods-image-info-order">ち：{{imageItem.displayOrderNum240}}</label>
            <label class="goods-image-info-order">さ：{{imageItem.displayOrderNum210}}</label>
            <label class="goods-image-info-order">とう：{{imageItem.displayOrderNum302}}</label>
            <label class="goods-image-info-order">な：{{imageItem.displayOrderNum515}}</label>
            <label class="goods-image-info-order" style="border-right: none;">に：{{imageItem.displayOrderNum451}}</label>

            <ul #useImageGroups [style.white-space]="'nowrap'" style="height: 190px;" class="block-row">
              <li *ngFor="let imageDetailItem of imageItem.imageDetailListInfo; let imageInd = index">
                <div class="element-column" *ngIf="imageInd < 4">
                  <div class="img_content">
                    <img [style.max-width.px]="142" [style.max-height.px]="142" src="{{imageDetailItem.fileImagePath}}">
                  </div>
                  <label>{{imageDetailItem.imageFileName}} {{imageDetailItem.cookingExPublish  === '1' ? '■' : '□' }}</label>
                </div>
              </li>
              <li>
                <button id="btn_Output" #btn_Output class="btn-secondary" style="width: 9rem;" [disabled]="permission !== '2' "
                  [tabindex]="0" (click)="eventImageAdd_CLICKHandler(item, imageItem, ind, imageInd)">新規画像登録</button>
                <button id="btn_Output" #btn_Output class="btn-secondary" style="width: 9rem;" [disabled]="permission !== '2' "
                  [tabindex]="0" (click)="eventImageUpdate_CLICKHandler(item, imageItem, ind, imageInd)">商品画像変更</button>
                <label style="visibility: collapse;">dummy</label>
                <app-checkbox-label #chk_SkewerSelect [label]="'串刺'" id="chk_SkewerSelect" [subid]="'chk_SkewerSelect'" [tabindex]="0"
                  [(ngModel)]="imageItem.skewerSelect" [disabled]="permission !== '2'" (ngModelChange)="eventSkewerSelect_CLICKHandler(item)">
                </app-checkbox-label>
              </li>
            </ul>

          </div>
        </div>
        <label class="goods-image-check flex-center" style="padding: 4px 8px; background-color: white;">
          <input type="checkbox" [tabindex]="-1" (mouseup)="$event.stopPropagation()"
            id="check" [(ngModel)]="item.imageChk" [disabled]="item.imageChkDisabledFlg || permission !== '2'"
            (ngModelChange)="eventCheckBox_CLICKHandler(item)"/>
        </label>
      </div>
    </div>
  </div>
</div>


<footer class="footer-buttons" style="z-index: 4;">
  <button id="btn_Output" #btn_Output class="btn-secondary" forcedEnabledMode="true"
    [tabindex]="0" (click)="eventOutput_CLICKHandler()">一覧出力</button>
  <!-- button 更新 -->
  <button id="btn_Update" #btn_Update class="btn-primary"  
    [tabindex]="0" (click)="eventUpdate_CLICKHandler()" forcedEnableMode="">更新</button>
</footer>